import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatIconModule } from '@angular/material';
import { StepComponent } from './step/step.component';
import { ProfileContactsComponent } from './profile-contacts/profile-contacts.component';
import { CollectionSettingsComponent } from './collection-settings/collection-settings.component';
import { IntegrationSettingsComponent } from './integration-settings/integration-settings.component';

@NgModule({
  declarations: [
    StepComponent,
    ProfileContactsComponent,
    CollectionSettingsComponent,
    IntegrationSettingsComponent,
  ],
  exports: [
    ProfileContactsComponent,
    CollectionSettingsComponent,
    IntegrationSettingsComponent,
  ],
  imports: [
    CommonModule,
    FlexLayoutModule,
    MatIconModule,
  ]
})
export class StepsModule { }
